import CustomTooltip from 'components/CustomTooltip';
import IconButton from 'components/ui/IconButton';
import useModelSave from 'pages/Editor/sections/Flow/hooks/useModelSave';
import { useEffect } from 'react';
import { IoSaveOutline } from 'react-icons/io5';
import styled from 'styled-components';
import { getCommandKeyName } from 'utils/commonUtils';

const Container = styled.div`
  position: relative;
`;

const SaveButton = () => {
  const { isLoading: isSaveLoading, save, onSaveClick } = useModelSave();

  useEffect(() => {
    const onKeydown = (event: KeyboardEvent) => {
      const { key, metaKey, ctrlKey } = event;

      if (key === 's' && (metaKey || ctrlKey)) {
        event.preventDefault();
        save();
      }
    };

    window.addEventListener('keydown', onKeydown);

    return () => {
      window.removeEventListener('keydown', onKeydown);
    };
  }, [save]);

  return (
    <Container>
      <IconButton
        className="header-save-button"
        $size={44}
        $hasRadius
        $hasBgColor
        onClick={onSaveClick}
        disabled={isSaveLoading}
      >
        <IoSaveOutline />
      </IconButton>
      <CustomTooltip anchorSelect=".header-save-button" hasDelay place="bottom">
        {`저장 (${getCommandKeyName('S')})`}
      </CustomTooltip>
    </Container>
  );
};

export default SaveButton;
